import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  TextField,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Import Link from react-router-dom
import Header from "../Header";
import Footer from "../Footer";
import events1 from "../../assets/images/events_1.png";
import events2 from "../../assets/images/events_2.png";
import calender from "../../assets/images/calender.svg";
import locationimg from "../../assets/images/location.svg";
import Snackbars from "../../utils/Snackbars";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";
import Search from "../../assets/images/search.svg";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getRequest } = useRequests();
  const [events, setEvents] = useState([]);
  const [bannerUrl, setbannerUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [poster, setPoster] = useState(null);
  const fetchEvents = async (posterDetail) => {
    const response = await getRequest("event-list");

    if (response && response.code === 200) {
      if(response.data.length!=0){

        const eventData = Array.isArray(response.data.data)
        ? response.data.data
        : [response.data.data];

      const today = new Date();
      today.setHours(0, 0, 0, 0);

        const filteredEvents = eventData.filter(
          (event) =>
            event.status === "Enable" && new Date(event.end_datetime) >= today
        );

        const specialEventId = 5;
        const sortedEvents = [
          ...filteredEvents.filter(event => event.e_id == specialEventId),
          ...filteredEvents.filter(event => event.e_id != specialEventId)
        ]
        setEvents(sortedEvents);
        setbannerUrl(response.data.banner);

        
        if(posterDetail.status=="Enable"){
          if(localStorage.getItem("popup") ==  "true"){
            filteredEvents.forEach(element => {
              console.log(element.e_id, posterDetail.e_id)
              if(element.e_id == posterDetail.e_id){
                setSelectedEvent(element);
                setPoster(posterDetail.poster);
                setOpenPopup(true);
              }
            });
          }
        }
      
      }
    } else {
      
      console.error("Failed to fetch events:", response?.message);
      setAlertData((prev) => ({
        ...prev,
        variant: "error",
        message: "Failed to fetch events",
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  const fetchPoster = async () => {
    const response = await getRequest("poster");
    if (response && response.code === 200) {

      fetchEvents(response.data);

    } else {
      console.error("Failed to fetch poster:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "error",
        message: "Failed to fetch poster",
      }));
    }
    resetAlertData();
  };

  React.useEffect(() => {
    let redirectPath = localStorage.getItem("redirectAfterLogin");
    
    // Priority 2: Check location state
    if (redirectPath) {
      localStorage.removeItem("redirectAfterLogin"); // Clean up after reading
      navigate(redirectPath);
    }

    fetchPoster();
    if (location.state && typeof location.state.message !== "undefined") {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
  }, []);

  const formatEventDate = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    // Format day and month
    const startDay = format(startDate, "dd"); // 01
    const endDay = format(endDate, "dd"); // 15
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy"); // 2025

    const daysCount = day;

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth}, ${year}`,
        daysCount,
      };
    }
    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth}, ${year}`,
      daysCount,
      // ({daysCount} Days)
    };
  };

  const [searchQuery, setSearchQuery] = useState("");
  const filteredEvents = events.filter((event) => {
    const city = `${event.city}`.toLowerCase().trim();

    const searchLower = searchQuery.toLowerCase().trim();

    return city.includes(searchLower);
  });

  const onPopupClose = () => {
    setOpenPopup(false);
    localStorage.setItem("popup", false);
  }

  const onBookTicket = () => {
    localStorage.setItem("popup", false);
    localStorage.setItem("bookfrompopup", true);
    navigate(`/dashboard/events-details/book-ticket/${selectedEvent.e_id}`)
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}

      <div className="center-App">
        <Header name="Events" />
        <Box
          sx={{
            padding: "15px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          <form className="loginForm">
            <div className="position-relative fullName">
              <img
                src={Search}
                alt="Full Name"
                width={19}
                className="textboxLefticon search"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Search City"
                autoComplete="off"
                type="text"
                name="fullName"
                className={`search-city`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ marginTop: 0 }}
              />
            </div>
          </form>

          <div container spacing={2}>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  minHeight: "300px",
                }}
              >
                <CircularProgress color="primary" />
                <p>Loading ...</p>
              </Box>
            ) : (
              <Box>
                {filteredEvents.length > 0 ? (
                  filteredEvents.map((event) => {
                    const { formattedDate } = formatEventDate(
                      event.start_datetime,
                      event.end_datetime
                    );
                    return (
                      <Box key={event.e_id} className="events-box">
                        <Link
                          to={`/dashboard/events-details/${event.e_id}`}
                          style={{ textDecoration: "none" }}
                        >
                          <Card
                            sx={{
                              borderRadius: "10px",
                              padding: "15px",
                              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                              WebkitAppearance: "none",
                              WebkitTransform: "translateZ(0)",
                            }}
                          >
                            <div className="position-relative radius-img-box">
                              <CardMedia
                                component="img"
                                height="185"
                                image={bannerUrl + event.banner}
                                alt={event.name}
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                className="events-date"
                              >
                                <img
                                  src={calender}
                                  alt=""
                                  className="calender-svg"
                                />
                                {formattedDate}
                              </Typography>
                            </div>
                            <CardContent style={{ padding: "9px 5px" }}>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#6638A2",
                                  marginTop: "5px",
                                  fontSize: "1.3rem",
                                  marginBottom: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                {event.name}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "8px",
                                  fontSize: "16px",
                                  color: "#341439",
                                }}
                              >
                                <img
                                  src={locationimg}
                                  alt="loc"
                                  className="location-svg"
                                />
                                {event.address}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Link>
                      </Box>
                    );
                  })
                ) : (
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ textAlign: "center", marginTop: "20px" }}
                  >
                    No events found.
                  </Typography>
                )}
              </Box>
            )}
          </div>
        </Box>

{selectedEvent && (
  <Dialog
  className="custom-dialo-event-popup"
    open={openPopup}
    onClose={onPopupClose}
    maxWidth="lg"           
    PaperProps={{
    sx: {
      borderRadius: '16px',  
    },
  }}
  >
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        position: "relative",
        color: "#000",           // purple event name
        fontWeight: 600,
        fontSize: "20px",
      }}
    >
      {selectedEvent.name}
      <IconButton
        aria-label="close"
        onClick={onPopupClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent>
      <img
        // src={bannerUrl + selectedEvent.banner}
        src={poster}
        alt={selectedEvent.name}
        style={{ width: "100%", borderRadius: "8px"}}
      />
      {/* <Typography
        variant="body1"  // bigger than body2
        sx={{ fontSize: "20px", color: "#341439", mb: 1 }}
      >
        {selectedEvent.address}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontSize: "20px", color: "#341439" }}
      >
        {
          formatEventDate(
            selectedEvent.start_datetime,
            selectedEvent.end_datetime
          ).formattedDate
        }
      </Typography> */}
    </DialogContent>

<DialogActions
  sx={{
    p: 2,
    justifyContent: "center", // ⬅️ centers the button
  }}
>
<Button
  variant="contained"
  sx={{
    backgroundColor: "#6638A2",
    "&:hover": {
      backgroundColor: "#512d81",
    },
    width: "210px",      // ⬅️ wider button
    height: "50px",      // ⬅️ taller button
    fontSize: "1.0rem",  // ⬅️ bigger text
    fontWeight: "bold",  // optional
    borderRadius: "8px"  // optional
  }}
  onClick={onBookTicket}
>
  Book Ticket
</Button>

</DialogActions>

  </Dialog>
)}



        <Footer />
      </div>
    </Box>
  );
};

export default Dashboard;
